export default {
  processingStockItems: [],
  stockItems: [],
  stockItem: undefined,
};
